//#region src/modules/Regions/constants.ts
var ALL_REGIONS_ID = "rgn-";
//#endregion
export { ALL_REGIONS_ID };

//# sourceMappingURL=constants.js.map